/**
 * Back after an in-page jump: saves the scroll position before a fragment link (#chapter) in a zg-*
 * section navigates, so Back returns to where the shopper clicked.
 *
 * From 990px Horizon scrolls inside .page-wrapper and sets history.scrollRestoration to 'manual'
 * (assets/scroll-container.js). It restores from history.state.scrollTop on popstate, but saves that
 * value only on pagehide and pushState, and a fragment navigation is neither. So Back from #chapter
 * found no saved position and stayed put. This writes the position into the current entry the same
 * way scroll-container.js does, just before the browser adds the fragment's entry; Horizon's popstate
 * handler then restores it. Below 990px the browser restores natively and Horizon's restore lands on
 * the same position.
 *
 * Loaded by the sections that render fragment links (zg-chapter-index, zg-cta-band, zg-page-hero);
 * the module runs once per page however many sections load it.
 */
import { getScrollContainer } from '@theme/scroll-container';

const REGISTERED = Symbol.for('zg-anchor-history');

/** @param {MouseEvent} event */
function onClick(event) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
  if (!(link instanceof HTMLAnchorElement) || !link.closest('.zg-section')) return;
  if ((link.getAttribute('href') ?? '').length < 2) return;
  if (link.target && link.target !== '_self') return;

  try {
    const currentState = typeof history.state === 'object' && history.state !== null ? history.state : {};
    history.replaceState({ ...currentState, scrollTop: getScrollContainer().scrollTop }, '');
  } catch (_) {
    // replaceState can throw if the state object exceeds the browser's size limit.
  }
}

if (!(/** @type {any} */ (window)[REGISTERED])) {
  /** @type {any} */ (window)[REGISTERED] = true;
  document.addEventListener('click', onClick);
}
